import gql from 'graphql-tag';
import { sanityDocumentFieldsFragment, supplyObjectFieldsFragment } from '@graphql/admin/fragments';

export const addSupplyObjectMutation = gql`
  mutation AddSupplyObject($input: CreateSupplyObjectInput!) {
    addSupplyObject(input: $input) {
      ...AdminSanityDocumentFields
      ...AdminSupplyObjectFields
    }
  }

  ${sanityDocumentFieldsFragment}
  ${supplyObjectFieldsFragment}
`;